import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { Route as LogsRoute } from "./$automationId.logs";
import { AutomationLogsJourneyPage, type AutomationLogsSearchState } from "./-automationLogsPage/automationLogsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/automations/$automationId/logs/$journeyId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { automationId, datasetSlug, journeyId } = Route.useParams();
  const search = LogsRoute.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const handleSearchChange = useCallback(
    (patch: Partial<AutomationLogsSearchState>) => {
      navigate({
        search: (previous) => {
          const next = { ...previous, ...patch };
          return Object.fromEntries(
            Object.entries(next).filter(([, value]) => value !== undefined && value !== ""),
          ) as AutomationLogsSearchState;
        },
        replace: true,
      });
    },
    [navigate],
  );

  return (
    <AutomationLogsJourneyPage
      automationId={automationId}
      datasetSlug={datasetSlug}
      journeyId={journeyId}
      search={search}
      onSearchChange={handleSearchChange}
    />
  );
}
